import { render } from "./card.vue?vue&type=template&id=6e20ca31&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=6e20ca31&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e20ca31"

export default script